module.exports = __webpack_public_path__ + "img/04-round-not-convex-3-base.7be819ee.svg";